export default __webpack_public_path__ + "static/cd-vs-cd-01e62386ffc5bc620c54385b9d70c605.png";